import { h, Component, Host, Prop, Method, State, Element } from '@stencil/core';

@Component({
  tag: 'pk-accordion-item-content',
  styleUrl: './pk-accordion-item-content.scss',
  shadow: true,
})
export class PkAccordionItemContent {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  @Element() el!: HTMLPkAccordionItemContentElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  @State() private itemIndex: number;

  // Public Property API
  // ========================

  /** Item is disabled */
  @Prop({ reflect: true }) disabled: boolean = false;

  /** Default expand state */
  @Prop({ reflect: true }) expanded: boolean = false;

  /** Disable transition effects */
  @Prop({ reflect: true }) noTransition: boolean = false;

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  /**
   *Set index for accordion-content
   * @param value
   */
  @Method()
  setIndex(value: number) {
    this.itemIndex = value;
    return Promise.resolve();
  }

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================
  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    return (
      <Host
        id={`accordion-content-${this.itemIndex}`}
        class={{ 'is-expanded': this.expanded, 'is-disabled': this.disabled, 'no-transition': this.noTransition }}
        aria-labelledby={`accordion-title-${this.itemIndex}`}
        role="region"
      >
        <div
          class="item-content overflow-hidden"
          aria-hidden={this.expanded ? 'false' : 'true'}
          hidden={!this.expanded}
          part="item-content"
        >
          <slot />
        </div>
      </Host>
    );
  }
}
